export enum SpriteStateIconsEnum {
  active = 'SuccessCircleIcon',
  pending = 'WarningCircleIcon',
  pendinguseraction = 'WarningCircleIcon',
  pendingappsetup = 'WarningCircleIcon',
  pendingemailsend = 'WarningCircleIcon',
  error = 'DangerCircleIcon',
  abandoned = 'UnknownCircleIcon',
  finalized = 'CancelCircleIcon',
}

export enum SpriteDeployStatusIconsMapper {
  SUCCESS = 'SuccessCircleIcon',
  QUEUED = 'QueueCircleIcon',
  'IN PROGRESS' = 'WarningCircleIcon',
  INPROGRESS = 'WarningCircleIcon',
  'NOT COMPLETED' = 'WarningCircleIcon',
  CANCELLED = 'CancelCircleIcon',
  FAIL = 'DangerCircleIcon',
  UNKNOWN = 'UnknownCircleIcon',
}

export enum DeploymentStatusEnum {
  SUCCESS = 'Success',
  QUEUED = 'Queued',
  'IN PROGRESS' = 'In progress',
  INPROGRESS = 'Inprogress',
  CANCELLED = 'Cancelled',
  'NOT COMPLETED' = 'notCompleted',
  FAIL = 'Fail',
  UNKNOWN = 'Unknown',
}
